module.exports = __webpack_public_path__ + "img/Nagpur-India.bb39084d.jpg";